<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="">
            <el-tabs v-model="currentType" type="card">
              <el-tab-pane label="问卷列表" name="list">
                <list v-if="currentType == 'list'"></list>
              </el-tab-pane>
              <el-tab-pane label="回收站" name="recycle">
                <recycle v-if="currentType == 'recycle'"></recycle>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import list from "./list"; //问卷列表
import recycle from "./recycle"; //回收站
import { addCache, updateCache } from "@/util/localAche.js";
export default {
  components: {
    Layout,
    list,
    recycle,
  },
  data() {
    return {
      tagList: [],
      currentType: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (
      ["/questionAdd", "/questionTopic", "/performance"].indexOf(from.path) ==
      -1
    ) {
      addCache("question-list", "");
      addCache("question-recycle-list", "");
    }
    if (["/questionTopic", "/questionAdd"].indexOf(from.path) == -1) {
      //如果不是从详情/题目回到列表就清空编辑缓存id
      addCache("question-edit", "");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (
      ["/questionAdd", "/questionTopic", "/performance"].indexOf(to.path) == -1
    ) {
      addCache("question-list", "");
      addCache("question-recycle-list", "");
      addCache("question-edit", "");
    }
    next();
  },

  created() {
    if (this.$route.query.type) {
      this.currentType = this.$route.query.type;
    } else {
      this.currentType = "list";
    }
  },

  watch: {
    $route() {
      if (this.currentType) {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        query.type = this.currentType;
        this.$router.push({ path: this.$route.path, query });
      }
    },
    currentType() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.type = this.currentType;
      this.$router.push({ path: this.$route.path, query });
    },
  },

  mounted() {},

  methods: {},
};
</script>
